import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateObject, IST_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { EapUserInstructionsModalComponent } from './eap-user-instructions-modal/eap-user-instructions-modal.component';
import { EapSummaryService } from '../../services/eap/eap-summary.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectApplicationtypeModelComponent } from 'src/app/common/operations-bar/select-applicationtype-model/select-applicationtype-model.component';
import { ColumnsSelectionPopupComponent, UserPreferenceColumns, UserPreferenceColumnsList } from 'src/app/common/columns-selection-popup/columns-selection-popup.component';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';


@Component({
  selector: 'app-eap-my-applications',
  templateUrl: './eap-my-applications.component.html',
  styleUrls: ['./eap-my-applications.component.scss']
})
export class EapMyApplicationsComponent implements OnInit {

  gridApi: GridApi;
  columnDefs: any[];
  operations: any[];
  tempoperations: any[];
  rowData;
  advanceSearch: any;
  selectedRow;
  caseDetails;
  requestType: any[];
  ProductsList: any[];
  StatusList: any;
  EAPApplicationsSearch: UntypedFormGroup;
  istapp: IST_APP;
  menudata: ModuleMenu;
  userType: string = "";
  collapesedOrNot:boolean=false;
  EAP_Display_Name: any;
  orgDetails: any;
  columns:any;
  userPreferenceColumnsLst: UserPreferenceColumnsList;
  ApplicationID:string = '';
  ApplicationType:string = '';
  PhysicianName:string = '';
  TherapeuticArea:string = '';
  RequestType:string = '';
  Product:string = '';
  StudyType:string = '';
  Owner:string = '';
  Status:string = '';
  ApplicationTypeList: any[];
  isHadPermission: boolean = false;
  maxDate = new Date(); 
  constructor(
    public route: ActivatedRoute,
    private summaryService: EapSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private userService: UserService,
    private GrantsService : GrantsSummaryService
  ) {

  }

  ngOnInit() {
    this.columns = this.route.snapshot.data["items"][0];
    if(this.route.snapshot.data["items"][1] != null){
      this.userPreferenceColumnsLst = this.route.snapshot.data["items"][1];
    }

    this.userType = this.userService.getUserType();

    this.orgDetails = this.commonService.getOrgDetails();
    this.EAP_Display_Name = this.orgDetails[0].EAP_DISPLAY_NAME;

    this.EAPApplicationsSearch = new UntypedFormGroup({
      Title: new UntypedFormControl(""),
      ApplicationType: new UntypedFormControl(""),
      PhysicianName: new UntypedFormControl(""),
      Product: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      StartDate: new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),
      StartDateO: new UntypedFormControl(null),
      EndDateO: new UntypedFormControl(null)
    });
    if (this.userType === "E") {
      this.tempoperations = [
        {
          "name": "New Application",
          "id": "add"
        }
      ];
    }
    else
      this.tempoperations = [];

    this.operations = this.tempoperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    if (this.userType == 'I') {
      let hadeditPermission = this.commonService.getScreenPermission("502", "E");
      if (hadeditPermission) {
        this.isHadPermission = true;
      }
      this.setUserPreferenceColumns();
      this.caseDetails = [
        {
          "caseSet": {
            "caseHeading": "General",
            "caseData": [
              {
                "label": "Application ID",
                "value": "APPLICATION_CODE"
              },
              {
                "label": "Physician Name",
                "value": "PhysicianName"
              },


              {
                "label": "Product",
                "value": "ProductName"
              },

              {
                "label": "Status",
                "value": "STATUSStr"
              },
              {
                "label": "Submitted On",
                "value": "SubmittedOnStr"
              },
              {
                "label": "Last Updated On",
                "value": "LastUpdatedStr"
              },
              {
                "label": "IRB Name",
                "value": "IRBName"
              },
              {
                "label": "#Total Requests",
                "value": "totalRequests"
              },
              {
                "label": "#Closed Requests",
                "value": "closedRequests"
              }
            ]

          }
        }
      ]
    }
    else if (this.userType == 'E') {
      this.isHadPermission = true;
      this.setUserPreferenceColumns();
      this.caseDetails = [
        {
          "caseSet": {
            "caseHeading": "General",
            "caseData": [
              {
                "label": "Application ID",
                "value": "APPLICATION_CODE"
              },
              {
                "label": "Product",
                "value": "ProductName"
              },

              {
                "label": "Status",
                "value": "STATUSStr"
              },
              {
                "label": "Submitted On",
                "value": "SubmittedOnStr"
              },
              {
                "label": "Last Updated On",
                "value": "LastUpdatedStr"
              },
              {
                "label": "IRB Name",
                "value": "IRBName"
              },
              {
                "label": "#Total Requests",
                "value": "totalRequests"
              },
              {
                "label": "#Closed Requests",
                "value": "closedRequests"
              }
            ]

          }
        }
      ]
    };

    this.getSummaryData();
    this.getApplicationtypes();
    this.GetStatusList();
   
  }

  GetStatusList() {
    this.summaryService.masterData("api/gmapp/getstatus/5").subscribe(result => {
      if (result != null) {
        this.StatusList = result;
        this.StatusList = [{ label: "Select", value: "-1", checked: true }, { label: "Returned", value: "Returned", checked: true }].concat(this.StatusList);

      }
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    switch(event.operationType){
      case 'edit':
       this.commonService.refreshApplicationPage(event.data["ID"], "eap");
        break;
      case 'rfi':
        this.commonService.LaunchingRequiredScreen(event.data["ID"],"eap","rfi_request");
        break;
      case 'mail':
        this.commonService.LaunchingRequiredScreen(event.data["ID"],"eap","correspondence_request");
        break;
    }
  }

  getApplicationtypes() {
    let submodule = "-1";
    let moduleID = "5";
    this.commonService.getAllApplicationTypesforSearch(moduleID, submodule).subscribe((result) => {
      if (result) {
        this.ApplicationTypeList = result;
      }
    });
  }
  
  add() {
    const modalRef = this['self'].modalService.open(SelectApplicationtypeModelComponent, { backdrop: false, windowClass: 'modal-md pt-5' });
    modalRef.componentInstance.Content = {
      heading: 'Select Application Type',
      custommessage: '',
      Proceed: "Proceed",
      Cancel: "Cancel",
      ModuleID: "5"
    }
    modalRef.result.then(result => {
      this['self'].GrantsService.getInstruction(result).subscribe(summary => {
        if (summary['isINSTRUCTIONS_ID']) {
          const ModelRef = this['self'].modalService.open(EapUserInstructionsModalComponent, {
            backdrop: false,
            keyboard: false,
            windowClass: 'modal-lg right modal-right',
            animation: true
          })
          ModelRef.componentInstance.Content = {
            id: "",
            ApplicationType: result
          }
        }
        else {
          this['self'].commonService.refreshApplicationPage("", "eap", result);
        }
      });
    });
  }

  getSummaryData() {
    this.SearchClear();
    this.summaryService.getApplicationSummary("api/EAPGeneralInfo/GetMyEAPApplicationsList").subscribe(summary => {
      this.rowData = summary["SummaryData"];
      this.requestType = [{ label: "All", value: "" }].concat(summary["MasterDrops"].MasterData1);
      this.ProductsList = [{ label: "All", value: "" }].concat(summary["MasterDrops"].MasterData2);
    });
  }
  getSummarySearch(searchObject: any) {
    this.summaryService.getEAPSearchSummary("api/EAPGeneralInfo/getEapSummarySearch", searchObject).subscribe(summary => {
      this.rowData = summary["SummaryData"];
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.EAPApplicationsSearch.reset();
  }
  AdvanceSearch() {
    var formData = this.EAPApplicationsSearch.value;

    if (formData["StartDate"] != null && formData["StartDate"] != undefined && formData["StartDate"] != 'Invalid Date') {
      formData["StartDateO"] = this.Submit_from_date;
    }
    if (formData["EndDate"] != null && formData["EndDate"] != undefined && formData["EndDate"] != 'Invalid Date') {
      formData["EndDateO"] = this.Submit_end_date;
    }
    this.getSummarySearch(formData);
  }

  Submit_from_date: DateObject;
  Submit_end_date: DateObject;

  submitfromDate(event) {
    this.EAPApplicationsSearch.get('EndDate')?.setValue(null);
    this.Submit_from_date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      HasValue: true

    };
  }
  submitendDate(event) {
    this.Submit_end_date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      HasValue: true
    }

  }
    selectColumns($event){
    let modalRef = this.modalService.open(ColumnsSelectionPopupComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md modal-dialog-center',
      animation: true
    });
         modalRef.componentInstance.Content = { columns: this.columns,moduleId:"5",isAllApplications: false};
    modalRef.result.then((result) => {
      this.getUserPreferenceColumns();
    });

  }

   setUserPreferenceColumns(){
    this.columnDefs = [];
     this.columns.forEach(x=>{
       if(x.FieldCode == 'APPLICATION_ID'){
        this.ApplicationID = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "APPLICATION_CODE"
          }
        );
      }
       if(x.FieldCode == 'APPLICATION_TYPE'){
        this.ApplicationType = x.ColumnName;
        this.columnDefs.push(
          {
             "headerName":  x.ColumnName,
            "field": "APPLICATION_TYPE_NAME"
          },
        );
      }
       if(x.FieldCode == 'PHYSICIAN_NAME'){
        this.PhysicianName = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "PhysicianName"
          }
        );
      }
       if(x.FieldCode == 'STATUS'){
        this.Status = x.ColumnName;
        this.columnDefs.push(
          {
            "headerName": x.ColumnName,
            "field": "STATUSStr"
          }
        );
      }
       if (x.FieldCode == 'PRODUCTIDS') {
         this.Product = x.ColumnName;
         if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.EapMyApplications) {
           if (this.userPreferenceColumnsLst.EapMyApplications.PRODUCTIDS) {
             this.columnDefs.push(
               {
                 "headerName": x.ColumnName,
                 "field": "ProductName"
               },
             );
           }
         }
       }
       if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.EapMyApplications) {
         if (this.userPreferenceColumnsLst.EapMyApplications.SUBMITTED_ON && x.FieldCode == 'SUBMITTED_ON') {
           this.columnDefs.push(
             {
               "headerName": x.ColumnName,
               "field": "SubmittedOnStr"
             },
           );
         }
       }
       if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.EapMyApplications) {
         if (this.userPreferenceColumnsLst.EapMyApplications.LAST_UPDATED_ON && x.FieldCode == 'LAST_UPDATED_ON') {
           this.columnDefs.push(
             {
               "headerName": x.ColumnName,
               "field": "LastUpdatedStr"
             }
           );
         }
       }
    })
       setTimeout(()=>{
      this.gridApi.refreshHeader();
      this.gridApi.sizeColumnsToFit();
       },500);
  }

   getUserPreferenceColumns(){
    this.commonService.GetUserPreferencesColumns().subscribe({
       next:res=>{
         if(res){
          this.userPreferenceColumnsLst = res;
        }
        this.setUserPreferenceColumns();
      }
    })
  }
}
